import React, { FunctionComponent } from 'react';
import type { Tv } from '../../../types/tvs';
import { Paginate } from '../../molecules/paginate';
import { Loading } from '../../atoms/loading';
import classnames from 'classnames';

const PAGINATE_PER = 20;

type Props = {
  tvs: Tv[];
  currentPage: number;
  isLoading: boolean;
  onPageChange: (newPage: number) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  tvs,
  currentPage,
  isLoading,
  onPageChange,
}) => {
  const shouldShowPagination = tvs.length !== 0 && Math.ceil(tvs.length / PAGINATE_PER) > 1;
  const paginatedTvs = (() => {
    if (currentPage > 1) {
      return tvs.slice((currentPage - 1) * PAGINATE_PER, currentPage * PAGINATE_PER);
    } else {
      return tvs.slice(0, PAGINATE_PER);
    }
  })();

  return (
    <>
      <div className={classnames('applicants-loading', 'blur', { 'is-active': isLoading })}>
        <Loading />
      </div>
      <ul className="tv-container">
        {paginatedTvs.length === 0 ? (
          <li className="empty">
            <h3 className='empty__title'>該当する動画が見つかりませんでした</h3>
            <p className='empty__content'>条件を変更して気になる動画を探してみましょう。</p>
          </li>
        ) : (
          paginatedTvs.map((tv) => (
            <li key={tv.id} className="tv-list gtm-movie-view-count" data-event-name='movie on screen' data-category="tvlist" data-value="panel">
              <a
                href={`/tvs/${tv.id}`}
                className="tv-link"
                data-event="click"
                data-category="tvlist"
                data-value="panel"
              >
                <div
                  style={{
                    background: `url(${tv.image}) no-repeat center center`,
                    backgroundSize: 'cover',
                    width: '100%',
                    height: 0,
                    paddingTop: '55.25%',
                  }}
                />
                <h2 className="tv-list-title">{tv.title}</h2>
                <div className="tv-list-info">
                  <span
                    className="tv-list-company"
                  >
                    {tv.companyName}
                  </span>
                  <div className="tv-list-numbers">
                    <p className="tv-list-numbers-date">{tv.updatedAt}</p>
                  </div>
                </div>
              </a>
          </li>
          ))
        )}
      </ul>
      {shouldShowPagination && (
        <Paginate
          current={currentPage}
          max={Math.ceil(tvs.length / PAGINATE_PER)}
          page="tvs"
          handleClick={(page: number) => onPageChange(page)}
        />
      )}
    </>
  );
};
